import { debounce } from 'underscore';

export const scaleRecaptcha = (recaptchaContainer) => {
    let storedHeight = '';

    if (!recaptchaContainer?.firstElementChild) {
        return;
    }

    const setStyles = (ratio) => {
        if (!ratio) {
            storedHeight = recaptchaContainer.firstElementChild.style.height;
            recaptchaContainer.firstElementChild.style.height = '';
        } else {
            recaptchaContainer.firstElementChild.style.height = storedHeight;
        }
        recaptchaContainer.firstElementChild.style.transform = ratio ? `scale(${ratio})` : '';
        recaptchaContainer.firstElementChild.style.transformOrigin = ratio ? '0 0' : '';
        recaptchaContainer.style.height = ratio ? `${Math.ceil(containerHeight * ratio)}px` : '';
    };
    // reset each time for get origin sizes
    setStyles();

    const { offsetWidth: containerWidth, offsetHeight: containerHeight } = recaptchaContainer;
    const { offsetWidth: captchaWidth = 304 } = recaptchaContainer.firstElementChild;

    if (captchaWidth > containerWidth) {
        setStyles(containerWidth / captchaWidth);
    }
};

export const addCaptchaChallengeClass = debounce(() => {
    const iFrameList = document.querySelectorAll('iframe');
    const captchaChallengeFrame = [...iFrameList].find(
        frame => frame.src.includes('google.com/recaptcha/api2/bframe')
    );

    if (captchaChallengeFrame) {
        captchaChallengeFrame.parentElement.classList.add('captcha-challenge-container');
    }
}, 2000);
